import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import useHttp from "../../../hooks/useHttp";
import LoaderImg from "../../../assets/media/loader.gif";
import { BALANCE_PAYMENT_URL } from "../../../utils/api-ends";

const BalancePayment = () => {
  const { isLoading, error, sendRequests } = useHttp();
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();
  const { paymentRequestId } = useParams();

  const handlePayment = () => {
    // Clear error msg
    setErrorMsg("");

    const response = (data) => {
      navigate(
        `/payment/${paymentRequestId}/response?response_message=Your balance payment is successfully completed.`
      );
    };
    sendRequests(
      {
        url: BALANCE_PAYMENT_URL,
        method: "post",
        data: {
          payment_request_id: paymentRequestId,
        },
      },
      response
    );
  };

  useEffect(() => {
    if (error?.error_msg) {
      setErrorMsg(error?.error_msg);
    }
  }, [error]);

  return (
    <div className="d-inline-block">
      {errorMsg?.length > 0 && (
        <div className="alert alert-danger" role="alert">
          {errorMsg}
        </div>
      )}
      <div className="multiple-btn mt-4">
        <button className="m-0" onClick={handlePayment}>
          Payment
          {isLoading && (
            <img src={LoaderImg} style={{ width: "22px" }} alt="" />
          )}
        </button>
      </div>
    </div>
  );
};

export default BalancePayment;
